import { args } from "@/lib/args/args";
import type { ParsedArgs } from "@/lib/parsed/parsed-args";
import type { CreateInput } from "@/commands/create/create-input";
import { HARNESSES } from "@/commands/harnesses/harnesses-constants";
import { TASK_TYPES } from "@/commands/task/task-types-constants";

export function createRunInput(
  parsed: ParsedArgs,
  prompt: string,
): CreateInput {
  const taskType = args.choice(parsed, "task-type", TASK_TYPES);
  const harness = args.choice(parsed, "harness", HARNESSES);

  return {
    prompt,
    ...(parsed.flags.title ? { title: parsed.flags.title } : {}),
    ...(taskType ? { taskType } : {}),
    ...(parsed.flags.model ? { modelSelection: parsed.flags.model } : {}),
    ...(harness ? { harnessPin: harness } : {}),
    ...(parsed.flags.repo ? { repoFullName: parsed.flags.repo } : {}),
    ...(parsed.flags.branch ? { branch: parsed.flags.branch } : {}),
    ...(parsed.repeated.skill ? { pinnedSkillIds: parsed.repeated.skill } : {}),
  };
}
